export const CLEANUP_BUSINESS_PAGE_STATE = 'cleanup-business-page-state';
const cleanupBusinessPageState = () => ({ type: CLEANUP_BUSINESS_PAGE_STATE });
export default cleanupBusinessPageState;
